import { useCallback } from 'react';

import { Button } from 'primereact/button';

import { useToggleSubscribedMutation } from '@/app/services/issues';

type ToggleSubscribeProps = {
  isSubscribed: boolean;
  requestId: number;
};

export const ToggleSubscribeButton = ({
  isSubscribed,
  requestId,
}: ToggleSubscribeProps) => {
  const [toggleSubscribed, { isLoading }] = useToggleSubscribedMutation();

  const handleToggleSubscribe = useCallback(() => {
    toggleSubscribed({
      id: requestId,
    });
  }, [toggleSubscribed, requestId]);

  return (
    <Button
      icon={isSubscribed ? 'pi pi-bell' : 'pi pi-bell-slash'}
      label={isSubscribed ? 'Subscribed' : 'Unsubscribed'}
      severity="secondary"
      className="subscription-button"
      onClick={handleToggleSubscribe}
      disabled={isLoading}
    />
  );
};
